exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".GuidePageEditor-c6ed9bf3{border:1px solid #E0E0E0;border-radius:2px}.Toolbar-4782bcc7{height:40px;background-color:#eee;display:flex;justify-content:space-between}.ToolbarButton-cd30dc90{display:inline-block;cursor:pointer;line-height:40px;margin:0 10px;color:#424242}.ToolbarButton-cd30dc90:hover{color:#FA6400}.ToolbarButton-cd30dc90.disabled-3e8367b2{color:#9E9E9E}.ToolbarButton-cd30dc90.disabled-3e8367b2:hover{color:#9E9E9E}.savingSpinner-0889000a{margin-right:5px}.Editor-695c183c{max-height:65vh;overflow:auto;padding:15px}.Editor-695c183c a{text-decoration:underline !important}.liveInfo-9b2eb569{margin-top:15px}.liveInfo-9b2eb569 a{font-weight:500}\n", ""]);

// Exports
exports.locals = {
	"GuidePageEditor": "GuidePageEditor-c6ed9bf3",
	"Toolbar": "Toolbar-4782bcc7",
	"ToolbarButton": "ToolbarButton-cd30dc90",
	"disabled": "disabled-3e8367b2",
	"savingSpinner": "savingSpinner-0889000a",
	"Editor": "Editor-695c183c",
	"liveInfo": "liveInfo-9b2eb569"
};